export const environment = {
  production: false,
  apiUrl: 'https://dynamo-api.vnod.net/api/v1',
  googleMapsApiKey: 'AIzaSyBlH9n7Hzp-eAcGYVvx_XrmG_M1VML7bCk',
};
